import useSWRMutation from "swr/mutation";

import { fetchPublicTracking } from "./api";

/**
 * Single-shot public tracking lookup (fires on `trigger(imb)`). The backend
 * caches each IMb for ~15 min, so this is a lookup, not a stream — don't
 * poll tightly.
 */
export function usePublicTracking() {
  return useSWRMutation(
    "public-tracking",
    (_key: string, { arg }: { arg: string }) => fetchPublicTracking(arg),
  );
}
